<template>
  <a
    :class="[varient, [type === 'button' ? 'button-lnk' : 'link']]"
    :href="reference"
    :disabled="disabled"
    @click="callback($event)"
  >
    <slot></slot>
  </a>
</template>

<script>
export default {
  props: {
    type: String,
    disabled: Boolean,
    varient: String,
    reference: String
  },
  methods: {
    callback(e) {
      this.$emit('click', e)
    }
  }
}
</script>
<style lang="scss">
.link {
  color: #00704a;
  text-decoration: underline;
}
.button-lnk {
  border: 1px solid #ddd;
  padding: 10px 0;
  color: #333;
  background-color: #fff;
  cursor: pointer;
  &[disabled] {
    cursor: not-allowed;
    pointer-events: none;
  }
  &.outline {
    background-color: transparent;
    color: #fff;
    display: block;
    text-align: center;
    border: 1px solid rgb(216, 216, 216);
    &:hover {
      text-decoration: none;
      background-color: white;
      color: #29413b;
      transition: all;
    }
  }
  &.outline-inverted {
    background-color: transparent;
    padding: 10px 15px !important;
    color: black;
    text-align: center;
    border: 1px solid black;
    &:hover {
      text-decoration: none;
      background-color: #29413b;
      color: white;
      transition: all;
    }
  }
  &.outline-white-inverted {
    background-color: white;
    padding: 10px 15px !important;
    color: #29413b;
    transition: all;
    &:hover {
      text-decoration: none;
    }
  }
  &.outline-inverted-active {
    background-color: #29413b;
    padding: 10px 15px !important;
    color: white !important;
    text-align: center;
    border: 1px solid black;
    &:hover {
      text-decoration: none;
      background-color: #29413b;
      color: white;
      transition: all;
    }
  }
}
</style>
